module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pgemnt-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "label-width": "80px",
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上级单位"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "placeholder": "输入关键字查询"
    },
    model: {
      value: (_vm.param.parentname),
      callback: function($$v) {
        _vm.$set(_vm.param, "parentname", $$v)
      },
      expression: "param.parentname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "机构名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "placeholder": "输入关键字查询"
    },
    model: {
      value: (_vm.param.name),
      callback: function($$v) {
        _vm.$set(_vm.param, "name", $$v)
      },
      expression: "param.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.batchBackSystem()
      }
    }
  }, [_vm._v("国家新闻出版署批量退回")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.hidePagin ? _vm.tableData : _vm.tableData.slice((_vm.currentPage - 1) * _vm.pageSize, _vm.currentPage * _vm.pageSize)
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1 + (_vm.currentPage - 1) * _vm.pageSize) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "上级单位",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(_vm._f("transParent")(scope.row.parent)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(_vm._f("translate")(scope.row.type, "level")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "流程",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(scope.row.flowName))]), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "goDeeper",
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(scope.row.flowId ? "已初始化" : ""))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "书号对应ID",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.level == 3) ? _c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(scope.row.tsorgid))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "left",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "line-height": "40px",
            "float": "left"
          }
        }, [(scope.row.level != 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('add', scope.row)
            }
          }
        }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('edit', scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (scope.row.level != 1) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('remove', scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setClaimId(scope.row)
            }
          }
        }, [_vm._v("设置书号ID")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('br') : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('span', {
          staticStyle: {
            "color": "black",
            "font-weight": "bold"
          }
        }, [_vm._v("创建审批流程：")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setWorks('1', scope.row)
            }
          }
        }, [_vm._v("音像")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setWorks('2', scope.row)
            }
          }
        }, [_vm._v("电子")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setWorks('3', scope.row)
            }
          }
        }, [_vm._v("连续电子")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('br') : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('span', {
          staticStyle: {
            "color": "black",
            "font-weight": "bold"
          }
        }, [_vm._v("生成申报资料清单：")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setMaterials('1', scope.row)
            }
          }
        }, [_vm._v("音像")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setMaterials('2', scope.row)
            }
          }
        }, [_vm._v("电子")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setMaterialsLxdz('3', scope.row)
            }
          }
        }, [_vm._v("连续电子")]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.hidePagin == false) ? _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "background": "",
      "layout": "total, prev, pager, next",
      "total": _vm.tableData.length,
      "page-size": _vm.pageSize,
      "page-sizes": _vm.sizesArray
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "pgemnt-4-dag",
    attrs: {
      "title": _vm.diaTitle,
      "visible": _vm.diaForAdd,
      "width": "480px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.diaForAdd = $event
      }
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "inpName"
  }, [_c('div', [_vm._v("名称：")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "inContent"
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.postDats.name),
      callback: function($$v) {
        _vm.$set(_vm.postDats, "name", $$v)
      },
      expression: "postDats.name"
    }
  })], 1)])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.diaForAdd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "inContent",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.goSave()
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "pgemnt-4-dag",
    attrs: {
      "title": "设置书号ID",
      "visible": _vm.diaForSetTsorgid,
      "width": "480px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.diaForSetTsorgid = $event
      }
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "inpName"
  }, [_c('div', [_vm._v("名称：")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "inContent"
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.tsorgid),
      callback: function($$v) {
        _vm.tsorgid = $$v
      },
      expression: "tsorgid"
    }
  })], 1)])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.closeCliamId()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "inContent",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.saveClaimId()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("机构管理")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-353a0f14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pgment/sectMent.vue
// module id = 1704
// module chunks = 1